import { useGLTF } from "@react-three/drei";
import { AssetMetadata } from "../models/Model3D";
import { useRef } from "react";
import { useFulfillState } from "../hooks/useCheckStateFullfilment";

export type AssetElementProps = {
  metadata: AssetMetadata;
}

export const AssetElement = (props: AssetElementProps) => {
  const { metadata } = props;
  const { path } = metadata;
  const gltf = useGLTF(path);
  const modelRef = useRef<any>();
  const visible = useFulfillState(metadata.stateRequirement, true)
  if (!visible) {
    return null;
  }
  return <primitive object={gltf.scene} ref={modelRef} />
}